<template>
  <HomeComponent />
</template>

<script lang="ts">
import HomeComponent from './components/HomeComponent.vue';

export default {
  components: { HomeComponent }
}
</script>

<style>

#app {
  font-family: Arial, Verdana, Avenir, Helvetica, sans-serif;
  font-size: 1.2rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
